var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoHiddenCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.922,
    height: 81.929,
    viewBox: "0 0 81.922 81.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1502",
    "data-name": "Rectangle 1502",
    width: 81.922,
    height: 81.929,
    fill: "#ef4c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9331",
    "data-name": "Path 9331",
    d: "M58.285,56.815c1.641,1.646,3.248,3.251,4.844,4.867a5.967,5.967,0,0,1,1.142,1.325.912.912,0,0,1-1.265,1.274,5.968,5.968,0,0,1-1.327-1.141c-1.615-1.6-3.218-3.2-4.818-4.8C40.647,72.75,17.435,68.61,6.6,53.737A33.7,33.7,0,0,1,13.451,6.751C29.026-4.912,48.866-.044,57.874,10.6a20.784,20.784,0,0,1-1.438,1.776Q36.242,32.6,16.023,52.807c-.312.311-.631.619-.972.9-.524.428-1.164.536-1.52-.075A1.449,1.449,0,0,1,13.7,52.3a31.418,31.418,0,0,1,2.934-2.99,15.292,15.292,0,0,0,4.239-6.07c.8-2.092,1.085-2.15,3.458-1.781l4.406-4.748c-.887-.31-1.86-.626-2.816-.99-3.659-1.391-6.15-3.8-6.37-7.9a9.412,9.412,0,0,1,4.738-9.092,29.015,29.015,0,0,1,4.883-1.951,16.886,16.886,0,0,1,1.867-.45c.047-1.061.072-2.067.142-3.071.1-1.463.551-1.943,2.013-2.094a7.823,7.823,0,0,1,1.759.032,1.758,1.758,0,0,1,1.737,1.9c0,.949,0,1.9,0,2.931,3.217,1.186,6.876.862,9.317,3.269L54.986,10.3c-.627-.532-1.463-1.314-2.373-2a31.577,31.577,0,0,0-41.334,3.045C2.638,20.192-.068,30.857,3.409,42.66,6.98,54.781,15.365,62.3,27.752,64.69A31.384,31.384,0,0,0,64.948,38.4,31.34,31.34,0,0,0,60.38,16.662c-.195-.312-.419-.608-.585-.935-.284-.557-.44-1.162.242-1.528a1.047,1.047,0,0,1,1.49.521,49.287,49.287,0,0,1,3.044,5.611c5.1,12.717,3.285,24.454-5.229,35.171-.315.4-.635.789-1.057,1.313M40.746,25.486l-.261-.684a15.561,15.561,0,0,0-9.387-.746,3,3,0,0,0-.808.343,2.377,2.377,0,0,0-1.3,2.147,1.991,1.991,0,0,0,1.376,2.05A43.188,43.188,0,0,0,35,29.936a1.842,1.842,0,0,0,1.371-.444c1.493-1.293,2.92-2.664,4.371-4.006",
    transform: "translate(0 0)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9332",
    "data-name": "Path 9332",
    d: "M35.224,48.728c-.047,1.072-.075,2.084-.14,3.095-.1,1.577-.445,1.92-1.979,2.033-.073.005-.146,0-.221.005-2.963.136-3.258-.144-3.329-3.126-.013-.507-.063-1.013-.1-1.654l-8.236-1.847,6.3-6c1.388.059,3.285.214,5.18.192a9.29,9.29,0,0,0,2.78-.565,2.119,2.119,0,0,0,1.486-2.006,2.14,2.14,0,0,0-1.337-2.106c-.928-.425-1.9-.746-2.774-1.081l6.586-6.328c2.718.848,5.521,2.5,6.474,6.049a9.43,9.43,0,0,1-2.989,9.987,12.211,12.211,0,0,1-5.027,2.64c-.839.236-1.685.447-2.674.707",
    transform: "translate(1.612 2.23)",
    fill: "#ef4c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9333",
    "data-name": "Path 9333",
    d: "M64.356,58.8a8.352,8.352,0,0,1,1.887,1.057q5.2,5.089,10.292,10.277c1.215,1.24,1.193,2.2.046,3.465-.936,1.033-1.929,2.021-2.958,2.962-1.278,1.171-2.246,1.223-3.464.032q-5.276-5.163-10.44-10.44a2.263,2.263,0,0,1-.091-3.35,42.539,42.539,0,0,1,3.115-3.115,8.154,8.154,0,0,1,1.613-.888",
    transform: "translate(4.479 4.468)",
    fill: "#ef4c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHiddenCharge);
export default __webpack_public_path__ + "static/media/no_hidden_charge.e16366324b93b2ad348369c4850e4574.svg";
export { ForwardRef as ReactComponent };